import { useCallback, useRef } from 'react';
import { useSiteContext } from '../../SiteContext';
export function useSiteEvent(component) {
    const { eventPlugins, paramPlugins } = useSiteContext();
    const paramPluginHookResultsRef = useRef([]);
    const eventPluginHookResultsRef = useRef([]);
    const componentRef = useRef(component);
    componentRef.current = component;
    // get all hooks for all plugins since we can't change the order of
    // react hook execution.
    // use refs for deps to avoid triggering when used inside useEffect
    paramPluginHookResultsRef.current = paramPlugins.map(plugin => {
        var _a;
        return ({
            type: plugin.type,
            hook: (_a = plugin.useHook) === null || _a === void 0 ? void 0 : _a.call(plugin)
        });
    });
    eventPluginHookResultsRef.current = eventPlugins.map(plugin => {
        var _a;
        return ({
            plugin,
            context: {
                componentId: component.id,
                hook: (_a = plugin === null || plugin === void 0 ? void 0 : plugin.useHook) === null || _a === void 0 ? void 0 : _a.call(plugin),
                params: paramPluginHookResultsRef.current
            }
        });
    });
    // perform the emit with the context data from above hooks
    const emit = useCallback((eventType, data) => {
        // console.log('emit', eventType, data, componentRef.current);
        for (const event of componentRef.current.events || []) {
            // console.log('event', event);
            const result = eventPluginHookResultsRef.current.find(e => e.plugin.type === event.type);
            // console.log('result', result);
            if (event.eventType === eventType && result) {
                result.plugin.handler(event.config, result.context, data);
            }
        }
    }, []);
    return { emit };
}
//# sourceMappingURL=useSiteEvent.js.map